import { Link } from 'react-router-dom';
import { format } from "date-fns";
import { Tooltip } from '@mui/material';

export const createLanguageColumn = (field, headerName, language, t, minWidth = 170) => ({
    field: field,
    headerName: t(headerName) + " " + t(language),
    flex: 1,
    minWidth: minWidth,
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
});

export const createOrderColumn = (t, minWidth = 140) => ({
    field: "orderNo",
    headerName: t("order"),
    flex: 0.3,
    minWidth: minWidth,
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    headerAlign: "center",
    align: "center",
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
});





export const createActiveColumn = (t, minWidth = 100) => ({
    field: "active",
    headerName: t("isActive"),
    sortable: false,
    flex: 0.3,
    minWidth: minWidth,
    headerAlign: "center",
    align: "center",
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    renderCell: (params) => params.row.isActive
        ? <span className=" text-success me-1 fw-bolder">{t("yes")}</span>
        : <span className=" text-danger me-1 fw-bolder">{t("no")}</span>

        
});


export const createIsMandatoryColumn = (t, minWidth = 100) => ({
    field: "isMandatory",
    headerName: t("isMandatory"),
    sortable: false,
    flex: 0.5,
    minWidth: minWidth,
    headerAlign: "center",
    align: "center",
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    renderCell: (params) => params.row.isMandatory
        ? <span className=" text-success me-1 fw-bolder">{t("yes")}</span>
        : <span className=" text-danger me-1 fw-bolder">{t("no")}</span>
        
});

export const createColumnAction = (
    t,
    editPath,
    removeFn,
    searchValue = "",  
    minWidth = 150
  ) => ({
    field: "action",
    headerName: t("action"),
    sortable: false,
    flex: 0.5,
    minWidth: minWidth,
    headerAlign: "center",
    align: "center",
    headerClassName: "tableHeaderClassName",
    cellClassName: "tableCellClassName",
    renderHeader: (params) => (
      <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    renderCell: (params) => (
      <div className="d-flex justify-content-center align-items-center">
        {editPath != null && (
          <Link
            to={`${editPath}/${params.row.id}`}
            state={{ search: searchValue }} 
            className="me-3"
          >
            <i className="bi bi-pencil-fill text-success"></i>
          </Link>
        )}
  
        {removeFn != null && (
          <div
            onClick={() => removeFn(params.row.id)}
            style={{ cursor: "pointer" }}
          >
            <i className="bi bi-trash-fill text-danger"></i>
          </div>
        )}
      </div>
    ),
  });

export const createActionColumn = (t, editPath, removeFn, minWidth = 150) => ({
    field: "action",
    headerName: t("action"),
    sortable: false,
    flex: 0.5,
    minWidth: minWidth,
    headerAlign: "center",
    align: "center",
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    renderCell: (params) => (
        <div className="d-flex justify-content-center align-items-center">
            {editPath != null && (
                <Link to={`${editPath}/${params.row.id}`} className="me-3">
                    {/* <i className="bi bi-pencil-fill text-primary"></i> */}
                    <i className="bi bi-pencil-fill text-success"></i>
                </Link>
            )}
            {removeFn != null && (
                <div
                    onClick={() => removeFn(params.row.id)}
                    style={{ cursor: "pointer" }}
                >
                    <i className="bi bi-trash-fill text-danger"></i>
                </div>
            )}
        </div>
    ),
});
export const createGroupActionColumn = (t, editPath, removeFn, minWidth = 180) => ({
    field: "action",
    headerName: t("action"),
    sortable: false,
    flex: 0.5,
    minWidth: minWidth,
    headerAlign: "center",
    align: "center",
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    renderCell: (params) => (
        <div className="d-flex justify-content-center align-items-center">
            <Link

                to={`/Group/StudentList/${params.row.id}`}
                className='text-primary cursor-pointer fw-bolder me-2'
            >
                
                {t("Student List")}
            </Link>
            {editPath != null && (
                <Link to={`${editPath}/${params.row.id}`} className="me-3">
                    <i className="bi bi-pencil-fill text-primary"></i>
                </Link>
            )}
            {removeFn != null && (
                <div
                    onClick={() => removeFn(params.row.id)}
                    style={{ cursor: "pointer" }}
                >
                    <i className="bi bi-trash-fill text-danger"></i>
                </div>
            )}
        </div>
    ),
});

export const usersCreateActionColumn = (t, editPath, removeFn, minWidth = 250) => ({
    field: "action",
    headerName: t("action"),
    sortable: false,
    flex: 0.5,
    minWidth: minWidth,
    headerAlign: "center",
    align: "center",
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    renderCell: (params) => (
        <>

            <Link to={`${editPath}/${params.row.id}`}>
                <i className="bi bi-pencil-fill text-success me-2"></i>
            </Link>
            <Link
                to={`/User/ChangePassword/${params.row.id}`}
                className='text-danger cursor-pointer fw-bolder me-2'
            >
                <i className="bi bi-lock-fill  " ></i>
                {"" + t("userChangePassword")}
            </Link>
            <div
                onClick={() => removeFn(params.row.id)}
                style={{ cursor: "pointer" }}
            >
                <i className="bi bi-trash-fill text-danger"></i>
            </div>
        </>
    ),
});

export const usersCreateDataAccessColumn = (t, facultyPath = null, levelPath = null, branchPath = null, minWidth = 250) => ({
    field: "dataAccess",
    headerName: t("dataAccess"),
    sortable: false,
    flex: 1,
    minWidth: minWidth,
    headerAlign: "center",
    align: "center",
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    renderCell: (params) => (
        <>
            <Link
                to={`/User/FacultyUser/${params.row.id}`}
                className='text-danger cursor-pointer fw-bolder ps-2'
            >
                <i className='bi bi-journal-text'></i>
                {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 24 24" className="me-1">
                    <path d="M12 2L2 7v2c0 1.105.895 2 2 2h1v8H3v2h18v-2h-2v-8h1c1.105 0 2-.895 2-2V7l-10-5zm7 15h-3v-7h3v7zm-5 0h-4v-7h4v7zm-6 0H5v-7h3v7zm13-10c0 .552-.447 1-1 1H4c-.553 0-1-.448-1-1V7.385l9-4.5 9 4.5V7z" />
                </svg> */}


                {" " + t("userFacultyDataAccess")}
            </Link>
            <Link to={`/User/BranchObjectUser/${params.row.id}`} className='text-danger cursor-pointer fw-bolder ps-2'>
                <i className='bi bi-building'></i>

                {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M3 21V8c0-.505.218-1 .605-1.34l7-6a1.003 1.003 0 0 1 1.29 0l7 6c.387.34.605.835.605 1.34v13h-5v-7H8v7H3zm2-2h3v-7h8v7h3V8.518l-7-6.005-7 6.005V19zm3-5h2v2H8v-2zm6 0h2v2h-2v-2z" />
                </svg> */}
                {t("userBranchObjectDataAccess")}
            </Link>
        </>
    ),
});
export const groupCreateActionColumn = (t, editPath, removeFn, minWidth = 250) => ({
    field: "action",
    headerName: t("action"),
    sortable: false,
    flex: 0.5,
    minWidth: minWidth,
    headerAlign: "center",
    align: "center",
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    renderCell: (params) => (
        <>
            <Link
                to={`/Group/StudentList/${params.row.id}`}
                className='text-primary cursor-pointer fw-bolder me-2'
            >
                <i className="bi bi-list text-primary " ></i>
                {t("studentList")}
            </Link>

            {editPath != null && (
                <Link to={`${editPath}/${params.row.id}`}>
                    <i className="bi bi-pencil-fill text-primary me-3"></i>
                </Link>
            )}
            {removeFn != null && (
                <div
                    onClick={() => removeFn(params.row.id)}
                    style={{ cursor: "pointer" }}
                >
                    <i className="bi bi-trash-fill text-danger"></i>
                </div>
            )}
        </>
    ),
});


export const createNewGeneralColumn = (
    field,
    headerName,
    t,
    minWidth = 120,
    customRenderCell = null,
    flex = 1
  ) => ({
    field,
    headerName: t(headerName),
    minWidth,
    flex,
    sortable: true,
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => <strong>{params.colDef.headerName}</strong>,
    renderCell: (params) => {
      const value = customRenderCell ? customRenderCell(params.value) : params.value;
      return (
        <Tooltip title={value || ''}>
          <span className="cell-ellipsis">{value}</span>
        </Tooltip>
      );
    }
  });

export const createGeneralColumn = (field, headerName, t, minWidth = 150, customRenderCell = null) => ({
    field: field,
    headerName: t(headerName),
    flex: 1,
    minWidth: minWidth,
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    renderCell: customRenderCell
        ? (params) => customRenderCell(params.value)
        : (params) => params.value // Default rendering if no customRenderCell is provided
});
export const createDateColumn = (field, headerName, t, minWidth = 100) => ({
    field: field,
    headerName: t(headerName),
    flex: 1,
    minWidth: minWidth,
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    valueFormatter: (params) => {
        // Format the date as yyyy-MM-dd
        if (params != null) {
            const date = new Date(params);
            return format(date, "dd/MM/yyyy");
        } else {
            return "-"
        }

        //return date.toISOString().split('T')[0];
    },
});

export const createTimeColumn = (field, headerName, t, minWidth = 100) => ({
    field: field,
    headerName: t(headerName),
    flex: 1,
    minWidth: minWidth,
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    valueFormatter: (params) => {
        // Format the date as yyyy-MM-dd
        const date = new Date(params.value);
        return format(date, "h:mm:ss");
        // return date.toISOString().split('T')[0];
    },
});

export const createBoolColumn = (field, headerName, t, minWidth = 140) => ({
    field: field,
    headerName: t(headerName),
    sortable: false,
    flex: 0.3,
    minWidth: minWidth,
    headerAlign: "center",
    align: "center",
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    // renderCell: (params) => params.row[field] 
    // ? <i className="bi bi-check-circle-fill text-success"></i>
    // : <i className="bi bi-x-circle-fill text-danger"></i>,
    renderCell: (params) => params.row[field]
        ? <i className="bi bi-check-square-fill text-success"></i>
        : <i className="bi bi-x-square-fill text-danger"></i>,
});

export const createDocumentColumn = (field, headerName, t, mainStore, minWidth = 150, filePath = "filePath") => ({
    field: field,
    headerName: t(headerName),
    flex: 1,
    minWidth: minWidth,
    headerClassName: 'tableHeaderClassName',
    cellClassName: 'tableCellClassName',
    renderHeader: (params) => (
        <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
    ),
    renderCell: (params) => {
        return (
            <a
                href={mainStore.systemDomain + params.row[filePath]}
                download
                target="_blank"
                rel="noopener noreferrer"
                style={{ cursor: "pointer" }}
                className="d-flex">
                {/* <i className="bi bi-file-earmark-fill text-info mx-1"></i> */}
                <i className="bi bi-file-earmark-fill text-info mx-1"></i>
                <div>{params.row[field]}</div>
            </a>
        );
    },
});

